/*
 * fn: getRankOverTimePoints
 *
 * Gets points for Rank Over Time graphs
 *
 */
import { type PageType } from '@/defs/page'
import { getDaysSinceEpoch } from '@/utils/formatUtil'

type Props = {
  rankOverTime?: NonNullable<PageType['charts']>['rankOverTime']
}

export const getRankOverTimePoints = ({ rankOverTime }: Props) =>
  Object.entries(rankOverTime || {})
    .map(([date, values]) => ({
      daysSinceEpoch: getDaysSinceEpoch(date),
      rank: values?.rank || 0,
    }))
    .filter(({ daysSinceEpoch, rank }) => daysSinceEpoch > 0 && rank > 0)
